import styled from "styled-components";
export const StyledContent = styled.span `
  height: auto;
  display: flex;
  align-items: center;
  font-weight: ${({ theme, isAutocomplete }) => isAutocomplete ? theme.fontWeights.regular : theme.fontWeights.medium};
  color: ${({ $color }) => $color};

  & strong {
    white-space: pre;
  }

  & .start {
    white-space: pre;
  }
`;
export const StyledFlyoutListItem = styled.li `
  &&& {
    padding: 0;
    margin: 0;
    display: flex;
    max-width: 100%;
    position: relative;
    align-items: center;
    overflow: hidden;
    word-break: break-word;
    min-height: 2.5rem;
    height: auto;
    ${({ disabled }) => (!disabled ? `cursor: pointer;` : "")};
  }

  > span:first-child {
    left: 0;
    min-height: 2.5rem;
    height: auto;
  }

  > span:last-child {
    margin-left: ${({ leftSpace, isActive, type }) => {
    if (leftSpace && !isActive && type === "withIcon") {
        return `2.5rem`;
    }
    if (leftSpace && isActive) {
        return `0`;
    }
    return `0.5rem`;
}};
    height: auto;
  }

  > div {
    height: auto;
    min-height: 2.5rem;
    flex: 1;
  }

  > div div {
    height: auto;
    min-height: 2.5rem;
    justify-content: center;
  }

  label {
    min-width: unset;
    max-width: initial;
  }

  font-size: ${({ theme }) => theme.fontTokens.font12[0]};
  line-height: ${({ theme }) => theme.fontTokens.font12[1]};
  font-weight: ${({ theme }) => theme.fontWeights.medium};

  box-sizing: border-box;
  color: ${({ disabled, theme, isActive }) => {
    if (disabled)
        return `rgba(${theme.colors.transparentBlack},0.26);`;
    if (isActive)
        return theme.colors.primaryLight;
    return theme.colors.black;
}};

  svg {
    fill: ${({ theme, type }) => type === "withIcon"
    ? theme.colors.primaryLight
    : type === "checkbox"
        ? theme.colors.white
        : theme.colors.black};

    ${({ theme, disabled }) => disabled ? `fill: rgba(${theme.colors.transparentBlack},0.26);` : ""};
  }

  @media ${({ theme }) => theme.device.medium} {
    > span:last-child {
      max-width: unset;
    }
  }

  @media ${({ theme }) => theme.device.touch} {
    min-height: 2.75rem;

    > span:first-child {
      height: auto;
      height: auto;
    }

    > span:last-child {
      height: auto;
      margin-left: ${({ leftSpace }) => {
    if (leftSpace) {
        return `2.75rem`;
    }
    return `0.5rem`;
}};
    }
  }

  &:focus {
    ${({ theme, focused }) => focused ? `outline: 2px solid ${theme.colors.primaryLight};` : "outline: none;"}
  }

  ${({ theme, disabled, hovered }) => !disabled && hovered
    ? `background-color: rgba(${theme.colors.transparentBlack},0.06);`
    : ""};
  @media (hover: hover) {
    &:hover {
      ${({ theme, disabled, hovered }) => !disabled && hovered
    ? `background-color: rgba(${theme.colors.transparentBlack},0.06);`
    : ""};
    }
  }

  &:active {
    ${({ theme }) => theme.global.disableTapHighlight}

    ${({ theme, disabled }) => !disabled
    ? `outline: 1px solid ${theme.colors.grey15}; background-color: ${theme.colors.grey15}; color: ${theme.colors.white};`
    : ""};

    label {
      ${({ theme, disabled }) => !disabled ? `color: ${theme.colors.white};` : ""};

      &:after {
        ${({ theme, disabled }) => !disabled ? `border-color: ${theme.colors.white};` : ""};
      }
    }

    span {
      ${({ theme, disabled }) => !disabled ? `color: ${theme.colors.white};` : ""};
    }

    svg {
      ${({ theme, disabled }) => !disabled ? `fill: ${theme.colors.white};` : ""};
    }
  }
`;
